import { getApiById, postApi, putApi } from "../../Shared/Services/RestService";
import {
  CandidateSettings,
  CandidateSettingsUpdate,
  ChangePasswordRequest,
  ChangePasswordResponse,
} from "../Types/CandidateSettingsType";

export const getCandidateSettings = (userId: string) => {
  return getApiById<CandidateSettings>("/candidate/settings", userId);
};

export const updateCandidateSettings = (
  userId: string,
  payload: CandidateSettingsUpdate
) => {
  return putApi<CandidateSettings>("/candidate/settings", userId, payload);
};

export const changeCandidatePassword = (
  userId: string,
  payload: ChangePasswordRequest
) => {
  return postApi<ChangePasswordResponse>(
    `/candidate/settings/${userId}/change-password`,
    payload
  );
};
